<mat-card class="widget mat-elevation-z8">
    <mat-card-title>
        Build Health (Today)
        <span class="grower"></span>
        <button mat-button mat-raised-button color="accent" 
            (click)="load()">{{reportButtonText()}}
        </button>
    </mat-card-title>
    <mat-card-content>
        <div id="build-health"></div>
        <div id="definition-health"></div>
    </mat-card-content>
</mat-card>